var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergingMarketSolutionsRgbRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,33h9v9H10Zm11,9h9V24H21ZM32,15V42h9V15H32ZM27.2361,8.2327,19.623,15H13.0068v7H6.0034v2h9.0034V17h5.377l8.2693-7.35,2.35,2.35V6h-6Z",
    fill: "#d70511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergingMarketSolutionsRgbRed);
export default __webpack_public_path__ + "static/media/emerging_market_solutions_rgb_red.dad647019f66cca38dfca00d34da644a.svg";
export { ForwardRef as ReactComponent };